// extracted by mini-css-extract-plugin
export default {"SearchForm":"Uh-PG","swapButton":"_8QmTi","isDesktop":"qTsYL","isMobile":"iTl1u","swapIcon":"_3KwGx","submitButton":"_5WGCJ","skeleton-progress":"_7sGFT"};